<template>
    <DModal
        v-model="form.activity_log_comment"
        :show="showModal"
        :title="__('customers.invoices.change_payment_method_modal_title')"
        is-confirm
        :show-change-reason-input="true"
        is-error
        :is-awaiting-validation="true"
        @close="closeModal()"
        @confirm="save"
    >
        <DCard
            class="card-height"
            padding
        >
            <DFormRow
                :label="__('customers.invoices.new_payment_method')"
                :hint="__('customers.invoices.change_payment_method_hint')"
                is-required
                is-vertical
                class="mb-0"
                :error="errors.payment_method"
            >
                <DSelect
                    id="payment_method"
                    v-model="form.payment_method"
                    :options="getAvailablePaymentMethods"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref } from 'vue'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    invoice: {
        type: Object,
        default: () => { return {} }
    },
    paymentMethods: {
        type: Object,
        default: () => { return {} }
    }
})

const getAvailablePaymentMethods = computed(() => {
    const currentPaymentMethod = props.paymentMethods.find((item) => item.value === props.invoice.payment_method)

    return [
        {
            value: null,
            label: currentPaymentMethod?.label ?? ''
        },
        ...props.paymentMethods.filter((item) => item.value !== props.invoice.payment_method)
    ]
})

const errors = ref({})

const form = useForm({
    invoice_id: props.invoice.id,
    payment_method: null,
    activity_log_comment: null
})

const emit = defineEmits(['close-modal'])

function closeModal () {
    emit('close-modal')
}

function save () {
    form.post(route('customers.customers.invoices.change_payment_method', { customer: props.invoice.customer_id }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        }
    })
}

</script>

<style lang="scss">
.card-height {
    height: 150px;
}
</style>
